import styled from 'styled-components';
import { TableCell, TransparentButton, Typography } from '@libs/components';
import { DropdownIcon } from 'src/assets';
type CustomAssetItemProps = {
  disabled?: boolean;
};
export const CustomAssetItem = styled(TransparentButton)<CustomAssetItemProps>`
  display: flex;
  align-items: center;
  padding: 0 2.3rem 0 2rem;
  width: 100%;
  height: 6.8rem;
  border: 1px solid
    ${({ theme, disabled }) =>
      disabled ? theme.colors.borders.disabled : theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background-color: ${({ theme, disabled }) =>
    disabled
      ? theme.colors.surface.disabled
      : theme.colors.surface.interactiveDefault};
`;
export const CustomAssetItemTextCont = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const CustomAssetItemInfo = styled(Typography)`
  margin-left: auto;
`;
export const CustomAssetItemDisabledText = styled(Typography)`
  margin-left: auto;
`;
export const CustomAssetItemImg = styled.div<CustomAssetItemProps>`
  max-width: 40px;
  max-height: 40px;
  width: 100%;
  object-fit: cover;
  margin-right: 0.8rem;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const ArrowIcon = styled(DropdownIcon)`
  width: 2.4rem;
  margin-left: 0.8rem;
`;

export const Img = styled.img`
  width: 4rem;
  max-height: 4rem;
`;

export const RightComponentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CustomTableCell = styled(TableCell)`
  white-space: nowrap;
`;
